// @view/document/review/SectionActionsDraft.view.tsx
import React from "react";
import { Button } from "@components/ui/button";
import * as styles from "@styles/SectionActions.css";
import * as Option from "@utils/Option";

import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";

type SectionActionsDraftViewProps = Pick<DocumentReviewViewProps, "handleDraft">;

const SectionActionsDraftView: React.FC<SectionActionsDraftViewProps> = ({
  handleDraft,
}) => {
  return (
    <div className={styles.actionCard}>
      <div className={styles.buttonContainer}>
        <Button
          className={styles.button}
          variant="outline"
          onClick={() => {
            IO.run(handleDraft(ok));
          }}
          asChild={Option.none()}
        >
          Interview
        </Button>
      </div>
    </div>
  );
};

export default SectionActionsDraftView;
